var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtentionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5799 5.59277L33.1987 24.3621L23.7446 14.153L19.5098 18.7261L33.1987 33.5084L54.8148 10.1659L50.5799 5.59277Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 37,
    fill: "#AA2C23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1871 41.96H39.7551L40.3311 30.344V18.008H33.6111V30.344L34.1871 41.96ZM37.1151 53.72C39.6111 53.72 41.5311 51.752 41.5311 49.112C41.5311 46.376 39.6111 44.408 37.1151 44.408C34.6191 44.408 32.5551 46.376 32.5551 49.112C32.5551 51.752 34.5711 53.72 37.1151 53.72Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtentionIcon);
export default __webpack_public_path__ + "static/media/atention-icon.0ae09401922ab1c56e0e15a8a5a2e20e.svg";
export { ForwardRef as ReactComponent };